import type { Filter } from '@/types/filter';

/**
 * Transforms the input filter object into a query string to pass through to the URL (endpoint).
 * Example usage:
 *
 * Input: `{ 'risk' : '4', 'source' : '1' }`
 *
 * Output: `'risk=4&source=1`
 * @returns
 */
export function getFilterQueries(filter: Filter): string {
    return Object.keys(filter)
        .map((key) => `${key}=${filter[key]}`)
        .join('&');
}
